import { createRoot } from 'react-dom/client';
import App from './App';
import { initPwaInstallListener, registerServiceWorker } from './lib/pwaInstall';
import './styles/global.css';

initPwaInstallListener();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void registerServiceWorker();
  });
}

createRoot(document.getElementById('root')!).render(<App />);
